import React, { useState, useEffect } from 'react';
import Modal from 'sushiweb/Modal';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import OTPbox from 'sushiweb/InputTypes/OTPbox';
import H4 from 'sushiweb/Typography/Heading/H1';
import Button from 'sushiweb/Button';
import { P } from 'sushiweb/Typography/Text';
import styled from 'styled-components';
import red from 'sushiweb/tokens/color/red';
import grey from 'sushiweb/tokens/color/grey';
import blue from 'sushiweb/tokens/color/blue';
import { RESEND_EXHAUST, SUBMIT_EXHAUST } from '../constants';

// Styles
const StyledP = styled(P)`
  font-size: 14px;
  justify-content: center;
  padding: 2rem;
  padding-bottom: 4rem;
  font-weight: 400;
`;

const StyledDiv = styled.div`
  text-align: center;
  padding: 1rem;
`;

const StyledH4 = styled(H4)`
  font-size: 24px;
  font-weight: 500;
  justify-content: center;
`;

const StyledCounter = styled.span`
  justify-content: center;
  font-size: 30px;
  visibility: ${props => (props.counter ? 'visible' : 'hidden')};
  transition: opacity 1s linear;
`;

const StyledResendButton = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: ${props => (props.counter || props.loading ? grey.z400 : red.z400)};
  cursor: pointer;
  pointer-events: ${props =>
    props.loading || props.counter ? 'none' : 'auto'};
`;

const StyledResend = styled(P)`
  font-size: 16px;
  font-weight: 400;
  justify-content: center;
  padding-bottom: 1rem;
  color: ${props => (props.state === 4 || props.state === 5) && red.z500};
`;

const Message = styled(P)`
  justify-content: center;
  padding: 1.5rem;
  color: ${props =>
    props.state === 3 || props.state === 1 ? blue.z500 : red.z500};
  font-size: 12px;
  font-weight: 400;
  visibility: ${props =>
    props.state === 2 || props.state === 3 ? 'visible' : 'hidden'};
`;

const TwoFactor = ({
  closeModal,
  isVisible,
  loading,
  body,
  submit,
  actionType,
}) => {
  const [callFlag, setCallFlag] = useState(false);
  const [resendClick, setResendClick] = useState(false);
  const { email = '', state = 0, message = '' } = body;
  const [counter, setCounter] = useState(30);
  const [otp, setOtp] = useState('');
  const [disableButton, setDisableButton] = useState(true);

  useEffect(() => {
    if (loading) setCallFlag(true);
  }, [loading]);

  useEffect(() => {
    // FF -> TF -> TT -> FT -> FF
    if (!loading && callFlag && resendClick) {
      setCounter(30);
      setCallFlag(false);
    }
  }, [loading, callFlag]);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const handleOnsubmit = () => {
    setResendClick(false);
    const data = { ...body, otp, actionType };
    submit(data);
  };

  const handleOnChange = () => {
    setDisableButton(true);
  };

  const fnInputFillCall = val => {
    setOtp(val);
    setDisableButton(false);
  };

  const handleResend = () => {
    if (counter === 0) {
      const data = { ...body, actionType };
      submit(data);
      setResendClick(true);
    }
  };

  //   const OTPboxRef = useRef();

  //   const testOnclick = () => {
  //       const allOtpBox = OTPboxRef.current.querySelectorAll('input');
  //       for(let i=0;i<allOtpBox.length;i+=1){
  //         allOtpBox[i].value = '';
  //       }
  //   }

  return (
    <Modal
      visible={isVisible}
      onClose={closeModal}
      type='medium'
      slideOnMobile
      isCentered
      padding='4rem 2rem'
      preventFocus
    >
      <StyledH4>OTP Verification</StyledH4>
      <StyledDiv>
        <StyledP>
          {email && `You will recieve a one time password on`}
          <br />
          {email}
        </StyledP>
        <OTPbox
          length={6}
          fnInputFill={fnInputFillCall}
          onChange={handleOnChange}
          inputType='number'
        />
        <Message state={state}>{message}</Message>
        {(state === 1 || state === 2 || state === 3) && (
          <StyledCounter counter={counter}>
            {counter >= 10 ? `00:${counter}` : `00:0${counter}`}
          </StyledCounter>
        )}
        {state === 4 || state === 5 ? (
          <StyledResend state={state}>
            {state === 4 ? RESEND_EXHAUST : SUBMIT_EXHAUST}
          </StyledResend>
        ) : (
          <StyledResend state={state}>
            Not recieved the code? &nbsp;
            <StyledResendButton
              counter={counter}
              loading={loading}
              onClick={handleResend}
            >
              Resend Now
            </StyledResendButton>
          </StyledResend>
        )}
        <Button
          onClick={state === 5 ? closeModal : handleOnsubmit}
          disabled={disableButton}
          loading={loading && resendClick === false}
        >
          {state === 5 ? 'Close' : 'Submit'}
        </Button>
      </StyledDiv>
    </Modal>
  );
};

TwoFactor.propTypes = {
  closeModal: PropTypes.func,
  isVisible: PropTypes.bool,
  loading: PropTypes.bool,
  body: PropTypes.object,
  actionType: PropTypes.string,
  submit: PropTypes.func,
};

TwoFactor.defaultProps = {
  closeModal: _noop,
  isVisible: false,
  loading: false,
  body: {},
  actionType: '',
  submit: _noop,
};

export default TwoFactor;
